import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

export function Drawer({
  open,
  anchor = 'right',
  width = 340,
  onClose,
  children,
}) {
  useEffect(() => {
    if (!open) return;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose?.();
      }
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <div className="drawer" role="presentation">
      <div className="drawer__backdrop" onClick={onClose} />
      <aside
        className={`drawer__panel drawer__panel--${anchor}`}
        style={{ width }}
      >
        {children}
      </aside>
    </div>,
    document.body,
  );
}
